/* @flow */

import { successColor } from '@e180/ui/lib/token/color';
import { gutter } from 'src/shared/app/base/style/token/grid';
import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    minHeight: 50,
    margin: 0,
    padding: [8, gutter],

    backgroundColor: successColor,
    color: white,

    fontSize: 14,
    fontStyle: 'italic',
    fontWeight: 500,
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',

    '$root a': {
      color: 'inherit',
    },
  },
};
